<template>
  <div class="contact-info" :class="{ 'is-dark': isDark }">
    <div class="contact-info-item">
      <h4>
        <img src="@/assets/img/phone_blue.png" width="26" />
        TELEFONE/WHATSAPP
      </h4>
      <p>
        <span class="big">(11) 3376-0100</span> - Matriz<br />Atendimento de
        segunda a sexta das 8h às 17h
      </p>
    </div>
    <div class="contact-info-item">
      <h4><img src="@/assets/img/svg/email.svg" width="20" />E-MAIL</h4>
      <p><span class="big">atendimento@crivelli.com.br</span></p>
    </div>
    <div class="contact-info-item">
      <h4>BAIXE NOSSO APLICATIVO</h4>
      <a
        href="https://play.google.com/store/apps/details?id=br.com.appfactory.crivelli"
        target="_blank"
        class="icon-app"
        ><img
          title="Google Store"
          src="@/assets/img/svg/download_google_app.svg"
      /></a>
      <a
        href="https://apps.apple.com/br/app/crivelli-advogados/id1271369437"
        target="_blank"
        class="icon-app"
        ><img
          title="Apple Store"
          src="@/assets/img/svg/download_apple_store.svg"
      /></a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isDark"],
};
</script>

<style>
</style>
